var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "8" } },
        [
          _c("w-select", {
            attrs: {
              value: _vm.value.Type,
              label: _vm.$ct("absolute-price-rule-type"),
              items: _vm.typeItems,
              fancy: "",
            },
            on: {
              input: function ($event) {
                return _vm.setType($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "4" } },
        [
          _vm.isPriceCategoryType
            ? _c("app-sell-price-category-select", {
                attrs: { "use-number": "", fancy: "", label: _vm.valueLabel },
                model: {
                  value: _vm.value.Value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Value", $$v)
                  },
                  expression: "value.Value",
                },
              })
            : _c("w-input-number", {
                attrs: { fancy: "", label: _vm.valueLabel },
                model: {
                  value: _vm.value.Value,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Value", $$v)
                  },
                  expression: "value.Value",
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }